module.exports = __webpack_public_path__ + "img/avatar-5.0a0cee92.jpg";